var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.471 24.4554L11.4719 24.4543C12.649 22.9811 14.5857 20.4524 16.2306 17.7841C17.053 16.4501 17.8084 15.0717 18.3596 13.7661C18.9073 12.4687 19.2708 11.2031 19.2708 10.1063C19.2708 4.98523 15.1176 0.833984 9.99844 0.833984C4.87739 0.833984 0.726074 4.9853 0.726074 10.1063C0.726074 11.2024 1.08662 12.4675 1.63112 13.7651C2.17905 15.0708 2.93056 16.4493 3.75047 17.7835C5.3901 20.4517 7.32675 22.9805 8.52691 24.4566C9.28927 25.4034 10.7092 25.403 11.471 24.4554ZM12.4226 10.1063C12.4226 11.443 11.3351 12.5305 9.99844 12.5305C8.66174 12.5305 7.57432 11.443 7.57432 10.1063C7.57432 8.76965 8.66174 7.68223 9.99844 7.68223C11.3351 7.68223 12.4226 8.76965 12.4226 10.1063Z",
    fill: "#004D8C",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinBlue);
export default __webpack_public_path__ + "static/media/pin_blue.05b4a0be1fea9ea63020b0841060cef5.svg";
export { ForwardRef as ReactComponent };